import { render, staticRenderFns } from "./ErrorSubmitForm20.vue?vue&type=template&id=aadfce3e&scoped=true"
import script from "./ErrorSubmitForm20.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm20.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadfce3e",
  null
  
)

export default component.exports